import React, { forwardRef } from 'react'
import { Text as RNText, type TextProps as RNTextProps } from 'react-native'
import { twMerge } from 'tailwind-merge'

import { toneClasses, type TypographyTone } from './tones'
import { type TypographyVariant, typographyVariants } from './variants'

export type TypographyProps = Omit<RNTextProps, 'style'> & {
    variant: TypographyVariant
    tone?: TypographyTone
    className?: string
}

type TypographyRef = React.ComponentRef<typeof RNText>

export const Typography = forwardRef<TypographyRef, TypographyProps>(
    ({ variant, tone = 'default', className, allowFontScaling = false, ...rest }, ref) => (
        <RNText
            ref={ref}
            className={twMerge(typographyVariants[variant], toneClasses[tone], className)}
            allowFontScaling={allowFontScaling}
            {...rest}
        />
    ),
)

Typography.displayName = 'Typography'
